<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">ALSO BY GEORGE BELLAIRS</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content">Littlejohn on Leave</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Four Unfaithful Servants</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death of a Busybody</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Dead Shall be Raised</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Stops the Frolic</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Murder of a Quack</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">He’d Rather be Dead</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Calamity at Harwood</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in the Night Watches</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Crime at Halfpenny Bridge</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Case of the Scared Rabbits</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death on the Last Train</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Case of the Seven Whistlers</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Case of the Famished Parson</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Outrage on Gallows Hill</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Case of the Demented Spiv</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Brings in the New Year</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Dead March for Penelope Blow</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in Dark Glasses</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Crime in Lepers’ Hollow</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">A Knife for Harry Dodd</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Half-Mast for the Deemster</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Cursing Stones Murder</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in Room Five</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Treads Softly</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Drops the Pilot</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in High Provence</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Sends for the Doctor</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Corpse at the Carnival</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Murder Makes Mistakes</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Bones in the Wilderness</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Toll the Bell for Murder</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Corpses in Enderby</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in the Fearful Night</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in Despair</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death of a Tin God</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Body in the Dumb River</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Before Breakfast</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Tormentors</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in the Wasteland</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Surfeit of Suspects</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death of a Shadow</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death Spins the Wheel</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Intruder in the Dark</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Strangers Among the Dead</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Death in Desolation</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Single Ticket to Death</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Fatal Alibi</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Murder Gone Mad</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Tycoon’s Deathbed</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Night They Killed Joss Varran</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Pomeroy, Deceased</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Murder Adrift</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Devious Murder</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Fear Round About</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">Close All Roads to Sospel</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">The Downhill Ride of Leeman Popple</p>
<p class="alignment-block-content alignment-block-content-center also-by-content">An Old Man Dies</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also-by-george-bellairs.vue?031cdd58